import { render, staticRenderFns } from "./JifenFenpei.vue?vue&type=template&id=257c89d2&scoped=true"
import script from "./JifenFenpei.vue?vue&type=script&lang=js"
export * from "./JifenFenpei.vue?vue&type=script&lang=js"
import style0 from "./JifenFenpei.vue?vue&type=style&index=0&id=257c89d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257c89d2",
  null
  
)

export default component.exports